import { useSubstructureMeta } from "./useSubstructureMeta";
export function useSubstructureInstanceMeta(substructure) {
    const substructureMeta = useSubstructureMeta();
    const { numInstances, attributePath } = substructureMeta;
    const instancePath = `${attributePath}/${substructure.index}`;
    const downwardPath = `${attributePath}/${substructure.index + 1}`;
    const upwardPath = `${attributePath}/${substructure.index - 1}`;
    const canMoveDownward = substructure.index < numInstances - 1;
    const canMoveUpward = substructure.index > 0;
    return Object.assign(Object.assign({}, substructureMeta), { instancePath,
        downwardPath,
        upwardPath,
        canMoveDownward,
        canMoveUpward });
}
//# sourceMappingURL=useSubstructureInstanceMeta.js.map